



















































































































































































































































































































































































































import {
  defineComponent,
  ref,
  computed,
  useFetch
} from '@nuxtjs/composition-api'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import CStepper from '~/components/shared/configurable/stepper/CStepper.vue'
import AdPlacementSections from '~/components/shared/advertising/AdPlacementSections.vue'
import RouteGuardService from '~/services/RouteGuardService'
import { useDep } from '~/compositions/dependency-container'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import AdvertiseService from '~/services/ads/AdvertiseService'
import CCircleProgressBar from '~/components/shared/configurable/progress-bar/CCircleProgressBar.vue'
import AdvertisingSteps from '~/components/shared/advertising/AdvertisingSteps.vue'
import { landingPageFaq } from '~/constants/advertising'

export default defineComponent({
  i18n: defineComponentTranslations({
    start_now: {
      en: 'Start now',
      el: 'Ξεκίνα τώρα'
    },
    campaign: {
      en: 'an Advertising Campaign',
      el: 'μια Διαφημιστική Καμπάνια'
    },
    hero_details: {
      en: `Car.gr is the largest classifieds website in Greece with more than 15 million private & dealer classifieds.`,
      el: `Το Car.gr είναι η μεγαλύτερη ιστοσελίδα αγγελιών στην Ελλάδα με περισσότερες απο 15 εκ. αγγελίες ιδιωτών & εμπόρων.`
    },
    earn_1: {
      en: 'Increase sales',
      el: 'Αύξηση πωλήσεων'
    },
    earn_2: {
      en: 'Boost Recognizability',
      el: 'Ενίσχυση Αναγνωρισιμότητας'
    },
    earn_3: {
      en: 'Increase visits',
      el: 'Αύξηση επισκέψεων'
    },
    stat_1: {
      en: 'Users / month',
      el: 'Χρήστες / μήνα'
    },
    stat_2: {
      en: 'Ad impressions / month',
      el: 'Διαφημιστικές προβολές / μήνα'
    },
    stat_3: {
      en: 'Mobile users',
      el: 'Χρήστες κινητών'
    },
    stat_4: {
      en: 'Desktop users',
      el: 'Χρήστες υπολογιστή'
    },
    stat_ages: {
      en: 'Age',
      el: 'Ηλικίες'
    },
    stat_gender: {
      en: 'Gender',
      el: 'Φύλα'
    },
    start_campaign: {
      en: 'Start a campaign',
      el: 'Δημιουργία καμπάνιας'
    },
    why_advertise: {
      en: 'Why advertise in Car.gr?',
      el: 'Γιατί να διαφημιστώ στο Car.gr;'
    },
    why_advertise_reason: {
      en:
        'Car.gr is the largest classifieds website in Greece with more than 15 million private & dealer classifieds.',
      el:
        'Το Car.gr είναι η μεγαλύτερη ιστοσελίδα αγγελιών στην Ελλάδα με περισσότερες από 15 εκ. αγγελίες ιδιωτών & εμπόρων.'
    },
    statistics: {
      en: 'Statistics',
      el: 'Στατιστικά'
    },
    data_cargr: {
      en: 'of Car.gr',
      el: 'στοιχεία Car.gr'
    },
    stats_date: {
      en: '(December 2023)',
      el: '(Δεκέμβριος 2023)'
    },
    what_to_earn: {
      en: 'What do I earn',
      el: 'Τι κερδίζω'
    },
    by_advertising: {
      en: ' by advertising on Car.gr?',
      el: ' με την διαφήμιση στο Car.gr;'
    },
    advertising_advantages_text: {
      en: `Car.gr is the necessary promotion tool for your business. Attract new customers,
           inventory retention, increased awareness & increased sales are just some of the profits you can have
           from the advertising platform.`,
      el: `Το Car.gr αποτελεί το απαραίτητο εργαλείο προβολής της επιχείρησής σου. Προσέλκυση νέων πελατών,
           διατήρηση υπαρχόντων, αύξηση της αναγνωρισιμότητας & αύξηση πωλήσεων είναι μόνο μερικά από τα κέρδη που μπορείς να έχεις
           από τη διαφημιστική πλατφόρμα.`
    },
    see_how_to_start: {
      en: 'See how to start',
      el: 'Δες πως να ξεκινήσεις'
    },
    ad_placements_title: {
      en: 'Ad placements for Professionals & Individuals',
      el: 'Τοποθεσίες διαφήμισης για Επαγγελματίες & Ιδιώτες'
    },
    ad_placements_title_start: {
      en: 'Ad placements ',
      el: 'Τοποθεσίες διαφήμισης '
    },
    ad_placements_title_end: {
      en: 'for Professionals & Individuals',
      el: 'για Επαγγελματίες & Ιδιώτες'
    },
    personalized_plan: {
      en: 'Personalized plan?',
      el: 'Εξατομικευμένο πλάνο;'
    },
    for_more_info: {
      en:
        'For more details or a customized advertising proposal, you can contact us by',
      el:
        'Για περισσότερες λεπτομέρειες ή μια προσαρμοσμένη διαφημιστική πρόταση, μπορείτε να επικοινωνήσετε μαζί μας με'
    },
    faq: {
      en: 'Frequently asked questions',
      el: 'Συχνές ερωτήσεις'
    }
  }),
  components: {
    AdvertisingSteps,
    CCircleProgressBar,
    AdPlacementSections,
    CImg,
    CCard,
    CCollapse,
    PlusMinusCollapseOpener,
    CStepper
  },
  setup() {
    const { locale } = useI18n()

    const advertisingService = useDep(AdvertiseService)
    const fetchedOptions = ref({})

    useFetch(async () => {
      const { schema } = await advertisingService.getUnitOptions()

      const { options } = schema.placementUnits

      fetchedOptions.value = options
    })

    const localeFaq = computed(
      () => landingPageFaq[locale] || landingPageFaq.en
    )

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))

    const routeGuardService = useDep(RouteGuardService)
    const isPc = computed(() => userAgentGetters('isPc'))

    const hasAccess = computed(() => {
      return routeGuardService.userCanUseInHouseAds() || isSingleOrAnon.value
    })

    return {
      localeFaq,
      isPc,
      hasAccess,
      isSingleOrAnon,
      fetchedOptions
    }
  },
  head() {
    return {
      title: this.$t('advertise in car.gr')
    }
  }
})
